export default __webpack_public_path__ + "static/mightyc-teaser2-mobilex2-6062c1746699a93aa56053e41f25c183.png";